'use client';

import styled from 'styled-components';

export const StyleCheckingPassword = styled.p`
  font-size: 14px;
  font-weight: 400;
  padding-left: 18px;
  position: relative;
  color: var(--color-warning);
  margin-bottom: 6px;
  line-height: 1.2;

  &.true {
    color: var(--color-success);

    &::before {
      background: var(--color-success);
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 48%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--color-warning);
  }
`;
